/**
 * .prevent-default
 * When an element with .prevent-default is clicked, we would stop propagaion of event
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

;$(function(){

    "use strict";

    /**
     * Define selector
     *
     * @type {String}
     */
    let $selector =  '.prevent-default';

    /**
     * Define method as a property
     *
     * @return closure
     */
    let disableLink = function(){
        $($selector).click(function(e){
            e.preventDefault();
        });
    }
    // Bind the method to Document
    $(document).ready(disableLink);
    // Bind the loaded.bs.modal to bind to remote modals
    $('#remote').on('loaded.bs.modal', disableLink);
});
